'use strict';

var _ = require('lodash');
var RulesReadonlySummaryController = function RulesReadonlySummaryController($scope, rulesService, featureToggleService) {
  $scope.ruleKeyForComments = 'technicalId';
  $scope.trimPOS = function (value) {
    if (featureToggleService.isDisabled('SPOS')) {
      return _.trimEnd(value, 'POS');
    } else {
      return value;
    }
  };
  $scope.formatFlowType = function (flowType) {
    return flowType ? _.capitalize(flowType.replace(/FlowType./g, '')) : '';
  };
  $scope.isQuickRule = function () {
    return rulesService.isQuickRule($scope.rule);
  };
  $scope.isCustomRule = function () {
    return rulesService.isCustomRule($scope.rule);
  };
  $scope.hasAppliedStrategies = function () {
    return rulesService.hasAppliedStrategies($scope.rule);
  };
  $scope.hasFurtherRestrictions = function () {
    return rulesService.hasFurtherRestrictions($scope.rule);
  };
  $scope.isQuickRuleWithTemplate = function () {
    return rulesService.isQuickRuleWithTemplate($scope.rule);
  };
  $scope.isQuickRuleWithLevel = function () {
    return rulesService.isQuickRuleWithLevel($scope.rule);
  };
  $scope.hasSecondaryCriteria = function () {
    return rulesService.hasSecondaryCriteria($scope.rule);
  };
  $scope.hasClassClosureTemplate = function () {
    return rulesService.hasClassClosureTemplate($scope.rule);
  };
  $scope.hasAllocationAuthAvailTemplate = function () {
    return rulesService.hasAllocationAuthAvailTemplate($scope.rule);
  };
};
RulesReadonlySummaryController.$inject = ['$scope', 'RulesService', 'FeatureToggleService'];
module.exports = RulesReadonlySummaryController;